<template>
    <div class="main-wrapper">
        <kh-slider-home :items="slider" />

        <kh-booking-engine :hotels="hotels"></kh-booking-engine>

        <kh-datetime></kh-datetime>
        
        <div v-if="weather" class="weather-wrapper">
            <span class="line"></span>
            <span class="temp">{{ weatherTemp }}°</span>
            <span class="line line2"></span>
            <span class="weather">{{ weather.weather[0].description }}</span>
        </div>
    </div>
</template>

<script setup>
import KhSliderHome from '@/components/SliderHome.vue';
import KhBookingEngine from '@/components/BookingEngine.vue';
import KhDatetime from '@/components/Datetime.vue';

import { computed } from 'vue';

const props = defineProps({
    slider: {
        type: Array,
        default: () => []
    },
    hotels: {
        type: Array,
        default: () => []
    },
    weather: {
        type: Object,
        required: false
    }
});

const weatherTemp = computed(() => {
    return Math.round(props.weather.main.temp);
});
</script>